var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTracker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 33,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#515864",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.143 28.571A3.439 3.439 0 0113.714 32a3.428 3.428 0 01-3.428-3.429zM13.714 0c1.423 0 2.572 1.067 2.572 2.39v1.083C21.189 4.556 24 8.65 24 13.54v3.957a8.499 8.499 0 00-4.403 8.787H0v-1.592l3.429-3.187v-7.965c0-4.907 2.794-8.985 7.714-10.068V2.39c0-1.323 1.148-2.39 2.571-2.39z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 17.5c-4.119 0-7.5 3.382-7.5 7.5 0 4.152 3.381 7.5 7.5 7.5s7.5-3.348 7.5-7.5c0-4.118-3.382-7.5-7.5-7.5zm0 13.828A6.334 6.334 0 0121.67 25c0-3.482 2.846-6.328 6.328-6.328 3.483 0 6.328 2.846 6.328 6.328S31.482 31.328 28 31.328z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.284 25.627l1.002 3.053 2.226-7.379-6.44 4.23z"
  }))));
}
export default SvgTracker;